import React from "react";
import CommonButtons from "src/shared/components/CommonButtons";
import { ModalWrapper } from "src/shared/components/ModalWrapper";

interface ConfirmActionModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isEditing?: boolean;
  adjustType?: "refund" | "deduct_from_due";
  setAdjustType?: (value: "refund" | "deduct_from_due") => void;
}

const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({ open, onClose, onConfirm, isEditing = false, adjustType = "refund", setAdjustType }) => {
  if (!open) return null;

  return (
    <ModalWrapper title={isEditing ? "Cancel Order" : "Create New Order?"} onClose={onClose} width="max-w-md">
      {isEditing && setAdjustType && (
        <div className="flex gap-4 mb-4">
          {/* <label className="flex gap-2 items-center">
            <input type="radio" checked={adjustType === "refund"} onChange={() => setAdjustType("refund")} />
            Refund
          </label> */}

          {/* Uncomment if needed */}
          {/* <label className="flex gap-2 items-center">
            <input
              type="radio"
              checked={adjustType === "deduct_from_due"}
              onChange={() => setAdjustType("deduct_from_due")}
            />
            Deduct from Outstanding
          </label> */}
        </div>
      )}

      <p className="mb-6 -mt-3 text-gray-700">{isEditing ? "Are you sure you want to cancel this order?" : "Are you sure you want to start a new order?"}</p>

      <div className="flex justify-end gap-3">
        <CommonButtons label="Cancel" variant="outlineDanger" onClick={onClose} />
        <CommonButtons label="Confirm" onClick={onConfirm} />
      </div>
    </ModalWrapper>
  );
};

export default ConfirmActionModal;
